<template>
  <div class="hello" v-if="fields.titlePost">
    <router-link to="./" class="return">back to list</router-link>
    <prismic-image :field="fields.imgPost" />

    <h2>
      <prismic-rich-text :field="fields.titlePost" wrapper="div" />
    </h2>

    <p>Fecha: {{ fields.datePost }}</p>

    <prismic-rich-text :field="fields.contentPost" wrapper="div" />
  </div>
</template>

<script>
export default {
  name: "Post",
  data() {
    return {
      fields: {
        titlePost: null,
        datePost: null,
        contentPost: null,
        imgPost: null
      }
    };
  },
  methods: {
    async getContent(uid) {
      const data = await this.$prismic.client.getByUID("post", uid);
      console.log(data);
      this.fields.titlePost = data.data.titlepost;
      this.fields.datePost = data.data.datepost;
      this.fields.contentPost = data.data.contentpost;
      this.fields.imgPost = data.data.imgpost;
    }
  },
  created() {
    this.getContent(this.$route.params.uid);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

img {
  max-width: 1280px;
  width: 100%;
  margin-top: 35px;
}

.hello {
  margin-bottom: 100px;
}
</style>
